

import "./galeria.css"

export default function Galeria() {


    return (

        <>

            <section className="gallery">

                <div className="prom_video">

                    <iframe id="video" src="https://www.youtube.com/embed/bQcGAV61irQ"
                        title="Vídeo Promocional Team Crezio" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen>
                    </iframe>

                </div>

                <div className="pictures_gallery">
                    <h1 className="pictures_gallery_title">Mural de Fotos</h1>
                    <p>Fotos aqui</p>

                </div>

            </section>

        </>

    )

}